import Popup from '@/components/popup'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import "./style.css"
import { errorToast, successToast } from '@/utils/toasters'
import {  CRButton } from '@/components/crRender'
import { useContext } from 'react'
import { DomainContext } from '@/context/DomainContext'
import { AddMissingDataMessage } from "@/api/endpoints"

const MissingDataPopup = ({title, name, modalID, PatientId}) => {
  const { ToggleReloadTable } = useContext(DomainContext)
  const { t } = useTranslation()
  const [ message, setMessage] = useState("")
  const[ sending, setSending]= useState(false)

  const handleSendMessage = async () =>{
    if(!message){
      return errorToast(t("missing-data-message-required"))
    }

    setSending(true)
    try {
      const res =  await AddMissingDataMessage(PatientId, message)
      successToast(t("operation-done-successfully"))
      ToggleReloadTable((p) => !p)
      modalID?.current?.click()
      setMessage("")
    } catch (e) {
      console.error(e)
    } finally {
      setSending(false)
    }
  }
  return (
        <Popup needbtn={false} large={true} title={title || name} name={name} modalID={modalID}>
            <div className='missing-data-wrapper'>
                 <textarea className='text-message' placeholder={t("write-your-message")} value={message} onChange={(e)=>setMessage(e.target.value)} />
                  <CRButton
                  title={t("send")}
                  className='missing-data-btn'
                  loading={sending}
                  onClick={handleSendMessage}
                  />
            </div>
        </Popup>
  )
}

export default MissingDataPopup